import { StreamMetadata } from "./streamMetadata";
import { decodeVarintInt32 } from "../../decoding/integerDecodingUtils";
export class MortonEncodedStreamMetadata extends StreamMetadata {
    num_bits;
    coordinate_shift;
    constructor(physicalStreamType, logicalStreamType, logicalLevelTechnique1, logicalLevelTechnique2, physicalLevelTechnique, numValues, byteLength, numBits, coordinateShift) {
        super(physicalStreamType, logicalStreamType, logicalLevelTechnique1, logicalLevelTechnique2, physicalLevelTechnique, numValues, byteLength);
        this.num_bits = numBits;
        this.coordinate_shift = coordinateShift;
    }
    static decode(tile, offset) {
        const streamMetadata = StreamMetadata.decode(tile, offset);
        const mortonInfo = decodeVarintInt32(tile, offset, 2);
        return new MortonEncodedStreamMetadata(streamMetadata.physicalStreamType, streamMetadata.logicalStreamType, streamMetadata.logicalLevelTechnique1, streamMetadata.logicalLevelTechnique2, streamMetadata.physicalLevelTechnique, streamMetadata.numValues, streamMetadata.byteLength, mortonInfo[0], mortonInfo[1]);
    }
    static decodePartial(streamMetadata, tile, offset) {
        const mortonInfo = decodeVarintInt32(tile, offset, 2);
        return new MortonEncodedStreamMetadata(streamMetadata.physicalStreamType, streamMetadata.logicalStreamType, streamMetadata.logicalLevelTechnique1, streamMetadata.logicalLevelTechnique2, streamMetadata.physicalLevelTechnique, streamMetadata.numValues, streamMetadata.byteLength, mortonInfo[0], mortonInfo[1]);
    }
    numBits() {
        return this.num_bits;
    }
    coordinateShift() {
        return this.coordinate_shift;
    }
}
//# sourceMappingURL=mortonEncodedStreamMetadata.js.map